"use client";

import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const textVariants = cva("", {
  variants: {
    variant: {
      default: "text-foreground",
      muted: "text-muted-foreground",
      primary: "text-primary",
    },
    size: {
      xs: "text-[10px]",
      sm: "text-xs",
      default: "text-sm",
      base: "text-base",
      lg: "text-lg",
    },
    weight: {
      default: "",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
    weight: "default",
  },
});

export interface TextProps
  extends
    Omit<React.ComponentProps<"span">, "ref">,
    VariantProps<typeof textVariants> {
  as?: "span" | "p" | "div" | "h3" | "h4" | "h5" | "dt" | "dd";
}

function Text({
  className,
  variant,
  size,
  weight,
  as: Comp = "span",
  ...props
}: TextProps) {
  return (
    <Comp
      className={cn(textVariants({ variant, size, weight }), className)}
      {...(props as React.HTMLAttributes<HTMLElement>)}
    />
  );
}

export { Text, textVariants };
